module.exports = __webpack_public_path__ + "static/media/login-background.de04aa6f.png";